import { Injectable } from '@angular/core';
import { ResponseFromFetch } from '../models/response-from-fetch.model';
import { AuthenticationErrors, ClientModel} from '../models/client.model';
import HttpStatusCode from '../enums/http-status.enum';
import { PasswordResponseModel } from '../models/password-response.model';
import { SessionStorageKeysEnum } from '../models/session-storage-keys-enum';
import { BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import {environment} from '../../../environments/environment';

@Injectable()
export class ProcessAuthenticationService {
    constructor(private readonly bdbSessionStorageService: BdbSessionStrgService,
    ) {

    }

    public processAuthenticationAttempt(passwordResponseFromFetch: ResponseFromFetch, clientModel: ClientModel): boolean {
        const passwordResponseStatusCode = passwordResponseFromFetch.status;
        if (passwordResponseStatusCode === HttpStatusCode.OK) {
            const passwordResponseBody = JSON.parse(passwordResponseFromFetch.body) as PasswordResponseModel;
            clientModel.setPasswordResponseBody(passwordResponseBody);
            this.bdbSessionStorageService.save(SessionStorageKeysEnum.MILESTONE, clientModel.clientAuthenticationMethod);
            this.bdbSessionStorageService.save(SessionStorageKeysEnum.IDENTIFY_TYPE_AUTHENTICATION,
                clientModel.authenticationMethodCode.toString());
            this.bdbSessionStorageService.save(SessionStorageKeysEnum.MILESTONE, clientModel.clientAuthenticationMethod);
            const isPasswordValid = passwordResponseBody.isValid;
            const isPasswordBlocked = passwordResponseBody.blocked;
            const method = passwordResponseBody.method;
            console.log('Autenticación por', method === '1' ? 'Token' : 'OTP');
            if (method === '2' && passwordResponseBody.safeInfo) {
                this.bdbSessionStorageService.save(SessionStorageKeysEnum.SAFE_DATA, passwordResponseBody.safeInfo);
            }
            if (isPasswordBlocked) {
                throw new Error(AuthenticationErrors.PASSWORD_IS_BLOCKED);
            } else if (method === '1' || method === '2') {
                return true;
            } else if (isPasswordValid) {
                this.bdbSessionStorageService.save(SessionStorageKeysEnum.ACCESS_TOKEN, passwordResponseBody.accessToken);
                return true;
            } else {
                throw new Error(AuthenticationErrors.PASSWORD_IS_WRONG);
            }
        } else {
            return false;
        }
    }

    public processAuthenticationAttemptWithSandboxV3(
        response: ResponseFromFetch
    ): boolean {
        const bodyRes = response.body;
        const code = bodyRes.code;
        const detail = bodyRes.data.detail;
        switch (code) {
            case HttpStatusCode.CREATED:
            case HttpStatusCode.OK:
                if (detail.Blocked) {
                    throw new Error(AuthenticationErrors.PASSWORD_IS_BLOCKED);
                } else if (detail.Valid || detail === 'Client validation successful') {
                    return true;
                }
                break;
            case HttpStatusCode.CONFLICT:
                throw new Error(AuthenticationErrors.PASSWORD_IS_WRONG);
            default:
                console.log('Status not mapped');
        }
        return false;
    }

    public getProcessAuthenticationSecureKey(response: ResponseFromFetch , clientModel?: ClientModel) {
        const isActiveSandboxV3 = environment.validateSecureKeyUseSandboxV3;
        return !isActiveSandboxV3 ? this.processAuthenticationAttempt(response, clientModel) :
        this.processAuthenticationAttemptWithSandboxV3(response);
    }

    public getProcessAuthenticationDebitCard(response: ResponseFromFetch , clientModel?: ClientModel) {
        const isActiveSandboxV3 = environment.validateDebitCardKeyUseSandboxV3;
        return !isActiveSandboxV3 ? this.processAuthenticationAttempt(response, clientModel) :
            this.processAuthenticationAttemptWithSandboxV3(response);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/process-authentication.service.ts